/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useEffect, useState, useCallback, useContext,
} from 'react';
import { motion } from 'framer-motion';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import Pagination from '../../Components/Pagination';
import FilterModal from './FilterModal';
import ListSkeleton from './listSkeleton';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import { CDN } from '../../constants';

function ProductListing() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [stockdetailsList, setStockDetailsList] = useState([]);
    const [sortType, setsortType] = useState('CONCATENATED_SEGMENTS+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [threeplList, setThreeplList] = useState([]);
    const [mainCategory, setMainCategory] = useState([]);
    const [Filter, setFilter] = useState({
        item_code: [],
        plant_name: [],
        product_categories: [],
    });
    const [threeDotLoader, setThreeDotsLoader] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const Arr = {
        A: 10,
        B: 21,
        C: 45,
    };

    const handleFetchMainCategories = async () => {
        const category = await distributorService.getOffersMainCategory();
        if (category.data.data.length > 0) {
            setMainCategory(category.data.data);
        }
    };

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data.data.success_status === true) {
            setThreeplList(data.data.Items);
        }
    };

    const handleFetchFGStockDetails = useCallback((() => {
        distributorService.AdminProductListing(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.data.success_status === true) {
                if (response.data.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setStockDetailsList(response.data.data.data);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.AdminProductListing(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.data.success_status) {
                SetSuccessMessage('Files exported Successfully');
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');

    useEffect(() => {
        handleFetchFGStockDetails();
        handleFetchthreepl();
        handleFetchMainCategories();
    }, [handleFetchFGStockDetails]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Categories and SKU’s</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] ${exportClick === true ? 'show' : 'hidden'} absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <ListSkeleton />
                : (
                    <div>
                        { stockdetailsList.length > 0 && (
                            <div className="overflow-auto dropdown-menu pb-7 relative z-10" style={{ height: 'calc(100vh - 298px)' }}>
                                <table className="w-full table-auto relative">
                                    <thead className="top-0 left-0 sticky z-[2]">
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-[5px] px-7 min-w-[200px] sticky top-0 left-0 rounded-bl- rounded-tl-lg bg-[#555259]" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Product Image
                                                </span>
                                            </th>
                                            <th className="py-[5px] px-6 min-w-[171px]" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Product Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Item Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Item Description
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    UOM
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    MOQ
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Standard Pack Size
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Size
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Sub-category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Segment 1
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Segment 2
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[230px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Delivery Lead Time
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[230px] rounded-br-lg rounded-tr-lg">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    AWS Classification
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stockdetailsList.length > 0 && stockdetailsList.map((item) => (
                                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td
                                                    className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 text-center"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                >
                                                    <motion.img
                                                        initial={{ opacity: 0, scale: 0.6 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        transition={{
                                                            duration: 0.8,
                                                            delay: 0.5,
                                                            ease: [0, 0.71, 0.2, 1.01],
                                                        }}
                                                        src={handleImage(item?.IMAGE_NAME)}
                                                        alt="icon"
                                                        className="w-full"
                                                    />
                                                </td>
                                                <td
                                                    className="text-sm font-normal text-[#090406] py-[5px] text-center px-7"
                                                >
                                                    {item?.CONCATENATED_SEGMENTS}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                    {item?.MODEL_DESCRIPTION}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.DESCRIPTION}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.PRIMARY_UOM_CODE}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.MINIMUM_ORDER_QUANTITY || 1}
                                                </td>
                                                {item?.PACKING_SIZE === null
                                                    ? (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            -
                                                        </td>
                                                    )

                                                    : (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            {item?.PACKING_SIZE}
                                                            {' '}
                                                            {item?.PRIMARY_UOM_CODE}
                                                        </td>
                                                    )}
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {`${item.DIAMETER !== null ? `${item.DIAMETER}mm` : ''}`}
                                                    {`${item.LENGTH !== null && item.DIAMETER ? 'x' : ''}`}
                                                    {`${item.LENGTH !== null ? `${item.LENGTH}mm` : ''}`}
                                                    {item.LENGTH === null && item.DIAMETER === null ? '-' : ''}
                                                </td>

                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.MAIN_CATEGORY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.SEGMENT2}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.SEGMENT3}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.SEGMENT4}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {Arr[item?.DELIVERY_LEAD_TIME] === (null || undefined) ? '-' : `${Arr[item?.DELIVERY_LEAD_TIME]} days`}
                                                </td>
                                                {item?.AWS_CLASSIFICATION === null
                                                    ? (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            -
                                                        </td>
                                                    )

                                                    : (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            {item?.AWS_CLASSIFICATION}
                                                        </td>
                                                    )}

                                            </tr>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        ) }
                        {stockdetailsList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={stockdetailsList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                threeplList={threeplList}
                                setThreeplList={setThreeplList}
                                mainCategory={mainCategory}
                                setMainCategory={setMainCategory}
                                stockdetailsList={stockdetailsList}
                                setStockDetailsList={setStockDetailsList}
                                Filter={Filter}
                                setFilter={setFilter}
                                handleFilter={handleFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFetchFGStockDetails={handleFetchFGStockDetails}
                                threeDotLoader={threeDotLoader}
                                setThreeDotsLoader={setThreeDotsLoader}
                            />
                        )}
                    </div>
                )}

            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Categories and SKU's"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}

        </div>
    );
}

export default ProductListing;
